import { useLocation } from 'react-router-dom';
import SiteSwitcher from '@/components/SiteSwitcher';
import Link from '@/lib/siteLink';
import { TrendingUp, Calculator, Scale, BookOpen, MessageSquare, Menu, X, Briefcase } from 'lucide-react';
import { useState } from 'react';
import NetworkFooter from './NetworkFooter';

export function FinanceHeader() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname } = useLocation();
  const isActive = (path) => pathname.startsWith(path) ? 'text-emerald-600 font-semibold' : 'text-gray-600';

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 border-b border-emerald-100/50 bg-white/90 backdrop-blur-md" data-testid="finance-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-14">
          <Link to="/finance" className="flex items-center gap-2" data-testid="finance-logo">
            <img src="/favicon-finance-192.png" alt="" width="28" height="28" className="w-7 h-7 rounded-md object-contain" />
            <span className="font-manrope font-bold text-lg tracking-tight">YourMoneyWise</span>
          </Link>

          <div className="hidden lg:flex items-center gap-6">
            <Link to="/finance/calculators" className={`text-xs font-medium hover:text-emerald-600 transition-colors flex items-center gap-1 ${isActive('/finance/calculators')}`} data-testid="nav-calculators">
              <Calculator className="w-3.5 h-3.5" /> Calculators
            </Link>
            <Link to="/finance/funds" className={`text-xs font-medium hover:text-emerald-600 transition-colors flex items-center gap-1 ${isActive('/finance/funds')}`} data-testid="nav-funds">
              <TrendingUp className="w-3.5 h-3.5" /> Fund Tracker
            </Link>
            <Link to="/finance/compare" className={`text-xs font-medium hover:text-emerald-600 transition-colors flex items-center gap-1 ${isActive('/finance/compare')}`} data-testid="nav-compare">
              <Scale className="w-3.5 h-3.5" /> Compare
            </Link>
            <Link to="/finance/learn" className={`text-xs font-medium hover:text-emerald-600 transition-colors flex items-center gap-1 ${isActive('/finance/learn')}`} data-testid="nav-learn">
              <BookOpen className="w-3.5 h-3.5" /> Learn
            </Link>
            <Link to="/finance/jobs" className={`text-xs font-medium hover:text-emerald-600 transition-colors flex items-center gap-1 ${isActive('/finance/jobs')}`} data-testid="nav-jobs">
              <Briefcase className="w-3.5 h-3.5" /> Jobs
            </Link>
            <Link to="/finance/blog" className={`text-xs font-medium hover:text-emerald-600 transition-colors flex items-center gap-1 ${isActive('/finance/blog')}`} data-testid="nav-blog">
              <MessageSquare className="w-3.5 h-3.5" /> News
            </Link>
          </div>

          <div className="flex items-center gap-3">
            <SiteSwitcher className="lg:hidden text-gray-600" />
            <button onClick={() => setMobileOpen(!mobileOpen)} className="lg:hidden p-1.5 text-gray-600" data-testid="mobile-menu-toggle">
              {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>
      </div>
      {mobileOpen && (
        <div className="lg:hidden border-t bg-white px-4 pb-4 pt-2 space-y-1" data-testid="mobile-menu">
          {[
            { to: '/finance/calculators', label: 'Calculators', icon: Calculator },
            { to: '/finance/compare', label: 'Compare', icon: Scale },
            { to: '/finance/learn', label: 'Learn', icon: BookOpen },
            { to: '/finance/jobs', label: 'Jobs', icon: Briefcase },
            { to: '/finance/blog', label: 'News', icon: MessageSquare },
          ].map(item => (
            <Link key={item.to} to={item.to} onClick={() => setMobileOpen(false)} className={`flex items-center gap-2 py-2 text-sm font-medium ${pathname.startsWith(item.to) ? 'text-emerald-600' : 'text-gray-700'}`}>
              <item.icon className="w-4 h-4" /> {item.label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
}

export function FinanceFooter() {
  return (
    <NetworkFooter
      activeSite="finance"
      bgClass="bg-gray-950"
      disclaimer="For educational purposes only. Not a SEBI-registered advisor. Consult a certified financial advisor before investing."
    />
  );
}
